import { useEffect, useState } from "react";
import "./style.css";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import { apiCreateGodown, apiListBranch } from "../../../api/master";
import godownSchema from "../../../validations/Godown";

function CompanyAdd(props) {
  const [user, setUser] = useState({});

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const [branch, setBranch] = useState([]);

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [selectedcode, setSelectedCode] = useState([]);
  const [shownew, setShownew] = useState(false);

  const handlecodeChange = (selectedcode) => {
    setSelectedCode(selectedcode);
    godownFormik.setFieldValue(
      "branch_id",
      selectedcode.map((option) => option.value),
    );
  };

  const stateListMap = branch?.flatMap((el) => {
    return {
      value: el?.branch_id,
      label: el.branch_name,
      isActive: el?.is_active,
    };
  });
  const godownFormik = useFormik({
    initialValues: {
      godown_name: "",
      godown_address: "",
      branch_id: [],
      tally_godown_name: "",
    },
    validationSchema: godownSchema.validateGodownAdd(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setIsSubmit(true);
      const decod = {
        godown_name: values.godown_name,
        tally_godown_name: values.tally_godown_name,
        godown_address: values.godown_address,
        branch_id: values.branch_id,
      };
      await apiCreateGodown(decod)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          setShownew(true);
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
        });
    },
    onReset: async (values) => {
      setSelectedCode([]);
      godownFormik.resetForm();
      setShownew(false);
      setSuccess("");
    },
  });

  async function getListBranch() {
    await apiListBranch({ paginate: 0 }).then((result) =>
      setBranch(result.data.data.list),
    );
  }

  useEffect(function () {
    getListBranch();
  }, []);

  useEffect(
    function () {
      const timer = setTimeout(() => {
        setSuccess("");
        setError("");
      }, 5000);
      return () => clearTimeout(timer);
    },
    [success, error],
  );
  console.log("godownFormik", godownFormik.values);
  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Add Godown
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={godownFormik.handleSubmit}
          onReset={godownFormik.handleReset}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="branch_name">
              Godown Name <span className="text-danger">*</span>
            </label>
            <input
              maxLength={45}
              type="text"
              className="form-control"
              id="godown_name"
              {...godownFormik.getFieldProps("godown_name")}
            />
            {godownFormik.errors.godown_name && shownew !== true ? (
              <div className="text-danger small">
                {godownFormik.errors.godown_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="tally_godown_name">Tally Godown Name</label>
            <input
              maxLength={45}
              type="text"
              className="form-control"
              id="tally_godown_name"
              {...godownFormik.getFieldProps("tally_godown_name")}
            />
            {godownFormik.errors.tally_godown_name && shownew !== true ? (
              <div className="text-danger small">
                {godownFormik.errors.tally_godown_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="godown_address">Godown Address</label>
            <input
              maxLength={100}
              type="text"
              className="form-control"
              id="godown_address"
              {...godownFormik.getFieldProps("godown_address")}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="state_id">
              Branch <span className="text-danger">*</span>
            </label>
            <Select
              isMulti
              options={stateListMap?.filter((el) => el?.isActive === true)}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  minHeight: "0px",
                }),
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
                input: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                  marginTop: "0px",
                  marginBottom: "0px",
                }),
                dropdownIndicator: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  paddingTop: "0px",
                  paddingBottom: "0px",
                }),
              }}
              value={selectedcode}
              classNamePrefix="react-select"
              tabSelectsValue
              onChange={handlecodeChange}
              name="branch_id"
            />
            {godownFormik.errors.branch_id && shownew !== true ? (
              <div className="text-danger small">
                {godownFormik.errors.branch_id}
              </div>
            ) : null}
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "end",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="reset"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  type="reset"
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default CompanyAdd;
